import { useMutation } from '@apollo/client/react';
import { useCallback, useEffect, useState } from 'react';

import { UpdateDescriptionDocument } from '~/graphql/generated/graphql';

export const useUpdateDescription = (appointmentId: string) => {
  const [isUpdating, setIsUpdating] = useState(false);
  const [latestMemo, setLatestMemo] = useState({ memo: '', mutationCalled: false });
  const [updateMemo, { data }] = useMutation(UpdateDescriptionDocument);

  useEffect(() => {
    if (!data) return;

    // Apollo or useMemo のキャッシュまわりの不整合が発生するので、メモ更新後は Mutation の返り値を使う
    // FYI https://github.com/medley-inc/pharms/issues/1852
    const latestDescription = data?.updateAppointmentDescription?.appointment?.description || '';

    // updateDescriptionData はリロード走るまで値を保持し続けるので、別の受付ドロワーを開いたタイミングでリセットできるようにステート管理する
    setLatestMemo({ memo: latestDescription, mutationCalled: true });
  }, [data]);

  const handleChangeMemo = useCallback(
    async (memo: string) => {
      if (appointmentId) {
        setIsUpdating(true);
        await updateMemo({
          variables: {
            input: {
              appointmentId,
              description: memo,
            },
          },
        });
        setIsUpdating(false);
      }
    },
    [appointmentId, updateMemo],
  );

  useEffect(() => {
    // 受付ドロワーを開いたタイミングでリセットする
    setLatestMemo({ memo: '', mutationCalled: false });
  }, [appointmentId]);

  return { updating: isUpdating, latestMemo, handleChangeMemo };
};
